import React from "react";

const HtmlStringRenderer = ({
  htmlString,
  componentMap,
}: {
  htmlString: string;
  componentMap: Record<
    string,
    { component: React.FC<any>; propsMap: Record<string, string> }
  >;
}) => {
  const parseHtmlString = (str: string) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(str, "text/html");

    const renderNode: React.FC<any> = (node: any) => {
      if (node.nodeType === Node.TEXT_NODE) {
        return node.textContent;
      }

      if (node.nodeType === Node.ELEMENT_NODE) {
        const tagName = node.tagName.toLowerCase();
        if (componentMap[tagName]) {
          const { component: Component, propsMap } = componentMap[tagName];
          const props = Object.fromEntries(
            [...node.attributes].map((attr) => [
              propsMap[attr.name] || attr.name,
              attr.value,
            ])
          );
          return <Component key={Math.random()} {...props} />;
        }

        return React.createElement(
          tagName,
          { key: Math.random() },
          [...node.childNodes].map(renderNode)
        );
      }

      return null;
    };

    return [...doc.body.childNodes].map(renderNode);
  };

  return <>{parseHtmlString(htmlString)}</>;
};

export default HtmlStringRenderer;
